import { useEffect, useState } from 'react';

/**
 * Tracks how much of the layout viewport is covered by the software keyboard
 * (or other visualViewport shrink) from the bottom edge, in CSS pixels.
 * Returns 0 when the keyboard is closed / visualViewport is unavailable.
 */
export function useKeyboardBottomInset(enabled = true): number {
  const [inset, setInset] = useState(0);

  useEffect(() => {
    if (!enabled || typeof window === 'undefined') {
      setInset(0);
      return;
    }

    const vv = window.visualViewport;
    if (!vv) {
      setInset(0);
      return;
    }

    const update = () => {
      const covered = Math.max(0, window.innerHeight - (vv.height + vv.offsetTop));
      // Ignore tiny jitter from browser chrome.
      setInset(covered > 24 ? Math.round(covered) : 0);
    };

    update();
    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    window.addEventListener('resize', update);

    return () => {
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, [enabled]);

  return inset;
}
